import store from "../store";
import Axios from "axios";
import { 
    CUSTOM_PURPOSES_LIST_REQUEST, 
    CUSTOM_PURPOSES_LIST_RECIEVE, 
    CUSTOM_PURPOSES_LIST_ERROR, 
    SET_CUSTOM_PURPOSES_LIST, 
    SET_CUSTOM_PURPOSES_LIST_URL 
} from "../action_types";


export const customPurposesListRequest = () => ({
    type: CUSTOM_PURPOSES_LIST_REQUEST,
});

export const customPurposesListRecieve = (list) => ({
    type: CUSTOM_PURPOSES_LIST_RECIEVE,
    list,
});

export const customPurposesListError = () => ({
    type: CUSTOM_PURPOSES_LIST_ERROR,
    list: {
        purposes: [],
        features: [],
        vendors: [],
    },
});

export const setCustomPurposesList = (list) => ({
    type: SET_CUSTOM_PURPOSES_LIST,
    list,
});

export const setCustomPurposesListURL = (url) => ({
    type: SET_CUSTOM_PURPOSES_LIST_URL,
    url,
});

export const fetchCustomPurposesList = () => (dispatch, getState) => {
    dispatch(customPurposesListRequest());
    return Axios.get(getState().customPurposesListURL, { crossdomain: true })
        .then((response) => {
            dispatch(customPurposesListRecieve());
            dispatch(setCustomPurposesList(response.data || {
                purposes: [],
                features: [],
            }));
        })
        .catch((err) => {
            dispatch(customPurposesListError());
        });
};

export const boundSetCustomPurposesList = (list) => store.dispatch(setCustomPurposesList(list));
export const boundCustomPurposesListRequest = () => store.dispatch(customPurposesListRequest());
export const boundCustomPurposesListRecieve = (list) => store.dispatch(customPurposesListRecieve(list));
export const boundCustomPurposesListError = () => store.dispatch(customPurposesListError());
export const boundSetCustomPurposesListURL = (url) => store.dispatch(setCustomPurposesListURL(url));
export const boundFetchCustomPurposesList = () => store.dispatch(fetchCustomPurposesList());